<template>
  <!-- 联系人方式 -->
  <div id="enterprise-card3">
    <div class="enterprise-card3-list">
      <div
        class="enterprise-card3-item"
        v-for="(item, index) in information.tableData"
        :key="index"
      >
        <div class="title">
          <div>
            <span class="title-name">{{ item.name || "--" }}</span>
            <span class="title-position">{{ item.position }}</span>
          </div>
          <!-- <div class="" style="font-size: 12px; color: #777e95;">
            推荐
          </div> -->
        </div>
        <div class="phone">
          <div class="phone-number">{{ item.phone }}</div>
          <div class="phone-tags">
            <span class="tag " v-if="item.location">{{ item.location }}</span>
            <span class="tag" v-if="item.activePr">{{ item.activePr }}</span>
            <span
              :class="{ tag: true, danger: item.checkStatus == '风险号' }"
              v-if="item.checkStatus"
              >{{ item.checkStatus }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    information: {
      type: Object,
      default: () => {},
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
#enterprise-card3 {
  width: 100%;
  .enterprise-card3-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .enterprise-card3-item {
      width: 32%;
      // min-height: 100px;
      margin-bottom: 10px;
      box-shadow: 0 0 8px #0000001a;
      border-radius: 4px;
      padding: 20px;
      margin: 5px;
      box-sizing: border-box;
      .title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .title-name {
          font-size: 18px;
          font-weight: 500;
          line-height: 18px;
          color: #111a34;
        }
        .title-position {
          margin: 0 4px 0 6px;
          font-size: 14px;
          line-height: 14px;
          color: #777e95;
        }
      }
      .phone {
        width: 100%;
        margin-top: 10px;
        display: flex;
        .phone-number {
          font-size: 15px;
          font-weight: 500;
          line-height: 18px;
          color: #111a34;
        }
        .phone-tags {
          display: flex;
          .tag {
            flex-shrink: 0;
            height: 18px;
            margin-left: 4px;
            padding: 3px 4px;
            color: #939fb8;
            font-weight: 700;
            font-size: 12px;
            line-height: 1;
            background: #f5f8ff;
            border-radius: 2px;
            box-sizing: border-box;
          }
          .danger {
            color: rgba(255, 81, 81, 0.65);
            background: #fff1f1;
          }
        }
      }
    }
  }
}
</style>
